
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { decimal_type, union_type, option_type, int32_type, record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { AusdruckModule_ofDecimal, Ausdruck, AusdruckModule_ofInt } from "./Ausdruck.jsx";
import { isNullOrEmpty, substring, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { int32ToString } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { fromParts } from "../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import Decimal from "../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import { Decimal_ParseDe_Z721C83C5 } from "./Basics.jsx";

export class InputError$1 extends Record {
    constructor(ActualValue, ExpectedValue, Message) {
        super();
        this.ActualValue = ActualValue;
        this.ExpectedValue = ExpectedValue;
        this.Message = Message;
    }
}

export function InputError$1_$reflection(gen0) {
    return record_type("MatheApp.Domain.InputError`1", [gen0], InputError$1, () => [["ActualValue", gen0], ["ExpectedValue", gen0], ["Message", string_type]]);
}

export class IntInput extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ValidInt", "ErrorInt"];
    }
    get HasValue() {
        const this$ = this;
        return IntInput__get_HasValue(this$);
    }
    get Ausdruck() {
        let v;
        const this$ = this;
        return (this$.tag === 1) ? (new Ausdruck(5, [AusdruckModule_ofInt(this$.fields[0].ActualValue)])) : ((this$.fields[0] == null) ? (new Ausdruck(4, [new Ausdruck(0, [])])) : ((v = (this$.fields[0] | 0), new Ausdruck(4, [AusdruckModule_ofInt(v)]))));
    }
}

export function IntInput_$reflection() {
    return union_type("MatheApp.Domain.IntInput", [], IntInput, () => [[["Item", option_type(int32_type)]], [["Item", InputError$1_$reflection(int32_type)]]]);
}

export function IntInput_Error_6F29BBBB(expected, actual, message) {
    return new IntInput(1, [new InputError$1(actual, expected, message)]);
}

export function IntInput__WithInput_Z524259A4(this$, digit) {
    if ((digit < 0) ? true : (digit > 9)) {
        return this$;
    }
    else if (this$.tag === 1) {
        return new IntInput(0, [digit]);
    }
    else {
        const currentOpt = this$.fields[0];
        const current = ((currentOpt == null) ? 0 : currentOpt) | 0;
        if (current > ~~((2147483647 - digit) / 10)) {
            return this$;
        }
        else {
            return new IntInput(0, [(current * 10) + digit]);
        }
    }
}

export function IntInput__Clear_Z1FBCCD16(this$, all) {
    let v;
    let matchResult, v_1;
    if (this$.tag === 0) {
        if (this$.fields[0] != null) {
            if ((v = (this$.fields[0] | 0), !all)) {
                matchResult = 0;
                v_1 = this$.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new IntInput(0, [(v_1 < 10) ? undefined : ~~(v_1 / 10)]);
        default:
            return new IntInput(0, [undefined]);
    }
}

export function IntInput__get_Value(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].ActualValue | 0;
    }
    else if (this$.fields[0] == null) {
        return 0;
    }
    else {
        const v = this$.fields[0] | 0;
        return v | 0;
    }
}

export function IntInput__get_ErrorMessage(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Message;
    }
    else {
        return "";
    }
}

export function IntInput__get_HasValue(this$) {
    if (this$.tag === 1) {
        return true;
    }
    else if (this$.fields[0] == null) {
        return false;
    }
    else {
        return true;
    }
}

export class DecimalInput extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ValidDecimal", "ErrorDecimal"];
    }
    get HasValue() {
        const this$ = this;
        return DecimalInput__get_HasValue(this$);
    }
    get Ausdruck() {
        const this$ = this;
        return (this$.tag === 1) ? (new Ausdruck(5, [AusdruckModule_ofDecimal(this$.fields[0].ActualValue)])) : (isNullOrWhiteSpace(this$.fields[0]) ? (new Ausdruck(4, [new Ausdruck(0, [])])) : (new Ausdruck(4, [new Ausdruck(2, [this$.fields[0]])])));
    }
}

export function DecimalInput_$reflection() {
    return union_type("MatheApp.Domain.DecimalInput", [], DecimalInput, () => [[["Item", string_type]], [["Item", InputError$1_$reflection(decimal_type)]]]);
}

export function DecimalInput_get_Empty() {
    return new DecimalInput(0, [""]);
}

export function DecimalInput_Error_6B54009B(expected, actual, message) {
    return new DecimalInput(1, [new InputError$1(actual, expected, message)]);
}

export function DecimalInput__WithInput_Z524259A4(this$, digit) {
    if ((digit < 0) ? true : (digit > 9)) {
        return this$;
    }
    else if (this$.tag === 1) {
        return new DecimalInput(0, [int32ToString(digit)]);
    }
    else {
        return new DecimalInput(0, [this$.fields[0] + int32ToString(digit)]);
    }
}

export function DecimalInput__WithKomma(this$) {
    if (this$.tag === 1) {
        return new DecimalInput(0, [","]);
    }
    else {
        const current = this$.fields[0];
        if (current.indexOf(",") >= 0) {
            return this$;
        }
        else {
            return new DecimalInput(0, [current + ","]);
        }
    }
}

export function DecimalInput__Clear_Z1FBCCD16(this$, all) {
    let matchResult, s_1;
    if (this$.tag === 0) {
        if (!all) {
            matchResult = 0;
            s_1 = this$.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new DecimalInput(0, [(s_1.length <= 1) ? "" : substring(s_1, 0, s_1.length - 1)]);
        default:
            return new DecimalInput(0, [""]);
    }
}

export function DecimalInput__get_Value(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].ActualValue;
    }
    else {
        const s = this$.fields[0];
        if (isNullOrEmpty(s)) {
            return fromParts(0, 0, 0, false, 1);
        }
        else {
            return Decimal_ParseDe_Z721C83C5(s);
        }
    }
}

export function DecimalInput__get_HasValue(this$) {
    if (this$.tag === 1) {
        return true;
    }
    else {
        return !isNullOrEmpty(this$.fields[0]);
    }
}

export function DecimalInput__get_ErrorMessage(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Message;
    }
    else {
        return "";
    }
}

export function Input_getAusdruck(value) {
    const matchValue = value;
    if (typeof matchValue === "number") {
        return AusdruckModule_ofInt(matchValue);
    }
    else if (matchValue instanceof Decimal) {
        return AusdruckModule_ofDecimal(matchValue);
    }
    else {
        return new Ausdruck(0, []);
    }
}

export class Editable$2 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Empty", "ReadOnly", "Edit"];
    }
    get Ausdruck() {
        const this$ = this;
        return (this$.tag === 1) ? Input_getAusdruck(this$.fields[0]) : ((this$.tag === 2) ? this$.fields[0].Ausdruck : (new Ausdruck(0, [])));
    }
}

export function Editable$2_$reflection(gen0, gen1) {
    return union_type("MatheApp.Domain.Editable`2", [gen0, gen1], Editable$2, () => [[], [["Item", gen0]], [["Item", gen1]]]);
}

